import { Component, OnDestroy, ViewChild } from '@angular/core';
import { IonModal } from '@ionic/angular';
import { ApplicationFacade, CardsNgrxFacade, CustomerCard } from '@ridango/components';
import { BaseComponent } from '@ridango/core';

@Component({
    selector: 'rwidget-card-block-modal',
    templateUrl: './card-block-modal.component.html',
    styleUrls: ['card-block-modal.component.scss']
})
export class CardBlockModalComponent extends BaseComponent implements OnDestroy {
    @ViewChild(IonModal) blockCardModal: IonModal;
    assetsPath$ = this.applicationFacade.assetsPath$;

    card: CustomerCard;

    constructor(
        private applicationFacade: ApplicationFacade,
        private cardsFacade: CardsNgrxFacade
    ) {
        super();
    }

    closeModal() {
        this.blockCardModal.dismiss(null, 'cancel');
    }

    openModal(card: CustomerCard) {
        this.card = card;
        this.blockCardModal.present();
    }

    blockCard() {
        this.cardsFacade.blockCard(this.card);
        this.closeModal();
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
